import { useEffect, useState } from "react";
import axiosAdmin from "../../../../api/apiAdmin";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import FaqCard from "./FaqCard";
import {
  MultyLangualTextArea,
  MultyLangualTextInput,
  SelectInputValueId,
  TextInput,
} from "../../inputComponents/inputcomp";
import { useTranslation } from "react-i18next";
import { apiError } from "../../../../api/apiError";

const FaqLayout = () => {
  const { t } = useTranslation();
  //add new user variable
  const [addNewToggler, setAddNewToggler] = useState(false);
  //get faq data from api
  const [faqData, setFaqData] = useState([]);
  //error
  const [error, setError] = useState(null);
  //affect data change depended on delete and add responses
  const [difResponses, setDifResponses] = useState(null);
  //new faq data
  const [newFaq, setNewFaq] = useState({
    mother: 0,
    title: "",
    titleen: "",
    text: "",
    texten: "",
  });
  //clear fields after submit
  const [makeEmpty, setMakeEmpty] = useState(false);

  //handle filed clear after submission
  const handleMakeEmpty = (value) => {
    setMakeEmpty(value);
  };

  //handle new faq
  const handleNewFaqData = (value, inputName) => {
    setNewFaq((prev) => ({ ...prev, [inputName]: value }));
  };

  //add new users handlers
  const handleAddNewToggle = (value) => {
    setAddNewToggler(value);
  };

  //add new faq
  const handleAddNewFaqToDb = async () => {
    try {
      const res = await axiosAdmin.post(`/faq`, newFaq);
      setDifResponses(res);
      if (res) {
        successToast(t("admin_added_success"));
        handleMakeEmpty(true);
      }
    } catch (error) {
      setError(error);
      errorToast(apiError(error, t("admin_error")));
    }
  };

  //delete faq
  const handleDeleteFaq = async (id) => {
    try {
      const res = await axiosAdmin.delete(`/faq/${id}`);
      setDifResponses(res);
      if (res) {
        successToast(t("admin_deleted_success"));
      }
    } catch (error) {
      setError(error);
      errorToast(apiError(error, t("admin_error")));
    }
  };

  //faq data from api
  useEffect(() => {
    try {
      axiosAdmin.get(`/faq`).then(({ data }) => {
        setFaqData(data);
      });
    } catch (error) {
      setError(error);
    }
  }, [difResponses]);

  return (
    <div className="xl:ml-[280px] mt-[55px] bg-slate-100 max-md:ml-0 dark:bg-slate-900">
      <div className="w-full pt-10 p-10 sm:p-5 flex flex-col gap-5">
        <div className="w-full flex items-center justify-end ">
          <button
            onClick={() => {
              handleAddNewToggle(true);
            }}
            className="sm:w-full rounded-lg p-3 text-white text-sm bg-violet-400 mx-5 sm:mx-0"
          >
            {t("admin_add_new_faq")}
          </button>
        </div>
        {addNewToggler && (
          <div className="bg-slate-100 dark:bg-slate-900 mx-5 sm:mx-0">
            <div className="sm:px-0">
              <div className="w-full rounded-xl bg-white dark:bg-slate-700 p-5">
                <div className="flex items-center justify-between flex-wrap gap-5">
                  <div className="flex items-center gap-5 sm:gap-3 ">
                    <div>
                      <h2
                        className="text-xl text-slate-400 font-bold dark:text-gray-400
                            sm:text-[16px] smd:text-[16px]"
                      >
                        {t("admin_add_new_faq")}
                      </h2>
                    </div>
                  </div>
                  <div className="flex gap-2 sm:w-full">
                    <button
                      onClick={handleAddNewFaqToDb}
                      className="rounded-lg p-3 text-white text-sm bg-violet-400 sm:w-full"
                    >
                      {t("admin_save")}
                    </button>
                    <button
                      onClick={() => {
                        handleAddNewToggle(false);
                      }}
                      className="rounded-lg p-3 text-white text-sm bg-red-400 w-10"
                    >
                      X
                    </button>
                  </div>
                </div>
                <SelectInputValueId
                  name={t("admin_categories")}
                  options={[
                    {
                      name: t("admin_payments"),
                      value: "payment",
                    },
                    {
                      name: t("admin_general"),
                      value: "general",
                    },
                    {
                      name: t("admin_customs_rules"),
                      value: "customs_rules",
                    },
                    {
                      name: t("admin_video_instruction"),
                      value: "video",
                    },
                  ]}
                  inputName={"mother"}
                  inputSetter={handleNewFaqData}
                />
                <MultyLangualTextInput
                  name={t("admin_branch_name")}
                  geInputName={"title"}
                  enInputName={"titleen"}
                  inputSetter={handleNewFaqData}
                />
                <MultyLangualTextArea
                  name={t("admin_answer")}
                  geInputName={"text"}
                  enInputName={"texten"}
                  inputSetter={handleNewFaqData}
                />
                <TextInput
                  name={"youtube embed url"}
                  inputName={"video"}
                  inputSetter={handleNewFaqData}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="w-full min-h-screen">
        <div className="grid grid-cols-2 sm:grid-cols-1  p-10 pt-0 sm:p-5 gap-2 sm:pt-0">
          {faqData.map((item) => {
            return (
              <FaqCard
                quistion={item.title && item.title}
                answer={item.text && item.text}
                id={item.id}
                key={item.id}
                handleDeleteFaq={handleDeleteFaq}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FaqLayout;
